module.exports = __webpack_public_path__ + "img/dynamic-bg.bf5e19c4.png";